import { NgModule, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ApolloModule, Apollo } from 'apollo-angular';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { onError } from 'apollo-link-error';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { NotifierService } from '../ui';

const introspectionQueryResultData = require('./fragment-types.json');

var appInjector: Injector;

function showError(message: string) {
  if (appInjector) {
    // Lookup the notifier service
    let notifier: NotifierService = appInjector.get(NotifierService);

    notifier.error(message);
  }
}

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    ApolloModule
  ],
})
export class ApiModule {
  
  constructor(
    injector: Injector,
    apollo: Apollo
  ) {
    appInjector = injector;

    const http = new BatchHttpLink({
      uri: '/api',
      batchInterval: 10, // 10ms
      credentials: 'same-origin',
    });

    const error = onError(({ graphQLErrors, networkError, operation }) => {

      if(graphQLErrors) {

        graphQLErrors.map(({ message}) => {
          showError(message);
        });
      }

      if(networkError) {

        if((networkError as any).status) {
          showError(`Erreur réseau, Code: ${(networkError as any).status}`);
        }
        else {
          showError('Erreur réseau, impossible de contacter le serveur');
        }
      }
    });

    const link = error.concat(http);

    // Create a fragment matcher
    // See https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher
    // Or for apollo-client@1.1.2 https://s3.amazonaws.com/apollo-docs-1.x/initialization.html#fragment-matcher
    // IMPORTANT: the fragment-types.json file was manually built using the example
    // Use http://localhost:3000/api/graphiql to get the schema
    const fragmentMatcher = new IntrospectionFragmentMatcher({
      introspectionQueryResultData
    });

    const cache = new InMemoryCache({
      dataIdFromObject: o => {
        if (o.__typename === 'ExecutionDossier') {
          return o['id'] + '/' + o['root_field'];
        }
        else {
          return o['id'];
        }
      },
      addTypename: true,
      fragmentMatcher,
    });

    apollo.create({
      link,
      cache,
      queryDeduplication: true
    });
  }
}
